import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { MView } from 'styles/mobilePageStyles'
import { Text } from 'styles/reactnative'
import { ThemeContext } from 'theme/ThemeProvider'
import PrivacyPolicyList from './PrivacyPolicyList'
import { PrivacyPolicySection } from './styles'

const PrivacyPolicy = () => {
	const { t } = useTranslation()
	const { textw } = useContext(ThemeContext).theme.COLORS
	return (
		<PrivacyPolicySection>
			<MView
				style={{
					width: '100%',
					height: 150,
					justifyContent: 'center',
				}}>
				<Text
					size={40}
					style={{
						alignItems: 'flex-start',
						fontWeight: '600',
						color: textw,
					}}>
					{t('privacyPolicy')}
				</Text>
			</MView>
			<PrivacyPolicyList />
		</PrivacyPolicySection>
	)
}

export default PrivacyPolicy
